import { ApiResponse } from "./api.service";

export class ExternalApiService {
  static async fetchDocnoteUrl(id: string, authKey: string): Promise<ApiResponse> {
    try {
      const baseUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${baseUrl}/api/v1.1/fetch/urlToViewInDocnote/${id}`, {
        headers: {
          "DOCNOTE-API-KEY": authKey,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, status: response.status, data };
    } catch (error) {
      return {
        success: false,
        status: error instanceof Error ? 500 : 500,
        data: { errMsg: error instanceof Error ? error.message : "An error occurred" },
      };
    }
  }
}
